import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class HumidityService extends BaseService<any> {

    humidityApi: string = environment.api_adm + 'v1/humidity';

    constructor(http: HttpClient) { super(http); }

    async getListhumidity(filter) {
        var fullUri = this.humidityApi + `/list`;
        if(filter){
            fullUri += "?" + this.builderFilter(filter)
        }

        return await this.http.get<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }
    async remove(ids) {
        const fullUri = this.humidityApi + `/deleteByIds`;

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: { ids: ids },
        };

        return await this.http.delete<any>(fullUri, options).toPromise();
    }
    async importFile(file) {

        const fullUri = this.humidityApi + `/csv/import`;
        return await this.http.post(fullUri, file, { headers: this.getOptionsFile() }).toPromise();
    }
    async gethumidityById(id){
        const fullUri = this.humidityApi + `/getById/${id}`;
        return await this.http.get<any>(fullUri, { headers: this.getOptions() }).toPromise();
    }
    async updatehumidity(data){
        const fullUri = this.humidityApi + `/update`;
        return await this.http.put(fullUri, data, { headers: this.getOptions() }).toPromise();
    }
    async addhumidity(data){
        const fullUri = this.humidityApi + `/create`;
        return await this.http.post(fullUri, data, { headers: this.getOptions() }).toPromise();
    }

    builderFilter(filter){
        var filterQuery = ""
        var isFirst = true;
        if(filter.hibrido){
            filterQuery += `hibrido=${filter.hibrido}`
            isFirst = false;
        }
        if(filter.safra){
            filterQuery += `${isFirst ? "" : "&" }safra=${filter.safra}`
            isFirst = false;
        }
        if(filter.padrao_percentil){
            filterQuery += `${isFirst ? "" : "&" }padrao_percentil=${filter.padrao_percentil}`
            isFirst = false;
        }
        if(filter.umidade_maxima){
            filterQuery += `${isFirst ? "" : "&" }umidade_maxima=${filter.umidade_maxima}`
            isFirst = false;
        }

        return filterQuery;
    }
}